import React from 'react';
import { useTranslation } from 'react-i18next';

const Rules = () => {
  const { t } = useTranslation();
  
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold mb-8 text-center">{t('rules.title')}</h1>

      {/* I. Preamble */}
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg dark:shadow-gray-900 p-8 mb-6">
        <h2 className="text-2xl font-bold mb-4 text-nba-blue">{t('rules.preamble')}</h2>
        <p className="text-gray-700 dark:text-gray-300 leading-relaxed">{t('rules.preambleText')}</p>
      </div>

      {/* II. Fairness and Behavior/Gameplay */}
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg dark:shadow-gray-900 p-8 mb-6">
        <h2 className="text-2xl font-bold mb-6 text-nba-blue">{t('rules.fairnessBehavior')}</h2>
        
        <div className="space-y-6">
          {/* Fast Breaks */}
          <div>
            <h3 className="text-lg font-semibold mb-2 text-nba-blue">{t('rules.fastBreaks')}</h3>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">{t('rules.fastBreaksText')}</p>
          </div>

          {/* No Quits */}
          <div>
            <h3 className="text-lg font-semibold mb-2 text-nba-blue">{t('rules.noQuits')}</h3>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">{t('rules.noQuitsText')}</p>
          </div>

          {/* Blowout Games */}
          <div>
            <h3 className="text-lg font-semibold mb-2 text-nba-blue">{t('rules.blowoutGames')}</h3>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">{t('rules.blowoutGamesText')}</p>
          </div>

          {/* Disconnects */}
          <div>
            <h3 className="text-lg font-semibold mb-2 text-nba-blue">{t('rules.disconnects')}</h3>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">{t('rules.disconnectsText')}</p>
          </div>

          {/* Inbounds */}
          <div>
            <h3 className="text-lg font-semibold mb-2 text-nba-blue">{t('rules.inbounds')}</h3>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">{t('rules.inboundsText')}</p>
          </div>

          {/* Intentional Fouls */}
          <div>
            <h3 className="text-lg font-semibold mb-2 text-nba-blue">{t('rules.intentionalFouls')}</h3>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">{t('rules.intentionalFoulsText')}</p>
          </div>

          {/* Pausing & Statistics */}
          <div>
            <h3 className="text-lg font-semibold mb-2 text-nba-blue">{t('rules.pausingStats')}</h3>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">{t('rules.pausingStatsText')}</p>
          </div>
        </div>
      </div>

      {/* III. Requirements */}
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg dark:shadow-gray-900 p-8 mb-6">
        <h2 className="text-2xl font-bold mb-6 text-nba-blue">{t('rules.requirements')}</h2>
        
        <div className="space-y-6">
          {/* Number of Games */}
          <div>
            <h3 className="text-lg font-semibold mb-2 text-nba-blue">{t('rules.numberOfGames')}</h3>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">{t('rules.numberOfGamesText')}</p>
          </div>

          {/* Shot Limitation */}
          <div>
            <h3 className="text-lg font-semibold mb-2 text-nba-blue">{t('rules.shotLimitation')}</h3>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">{t('rules.shotLimitationText')}</p>
          </div>

          {/* Lock-On Defense */}
          <div>
            <h3 className="text-lg font-semibold mb-2 text-nba-blue">{t('rules.lockOnDefense')}</h3>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">{t('rules.lockOnDefenseText')}</p>
          </div>

          {/* Points in Zone */}
          <div>
            <h3 className="text-lg font-semibold mb-2 text-nba-blue">{t('rules.pointsInZone')}</h3>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">{t('rules.pointsInZoneText')}</p>
          </div>

          {/* Headset Requirement */}
          <div>
            <h3 className="text-lg font-semibold mb-2 text-nba-blue">{t('rules.headsetRequirement')}</h3>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">{t('rules.headsetRequirementText')}</p>
          </div>

          {/* Media */}
          <div>
            <h3 className="text-lg font-semibold mb-2 text-nba-blue">{t('rules.media')}</h3>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">{t('rules.mediaText')}</p>
          </div>
        </div>
      </div>

      {/* IV. Standings, Play-In & Playoffs */}
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg dark:shadow-gray-900 p-8 mb-6">
        <h2 className="text-2xl font-bold mb-6 text-nba-blue">{t('rules.standingsPlayoffs')}</h2>
        
        <div className="space-y-4">
          <p className="text-gray-700 dark:text-gray-300 leading-relaxed">{t('rules.endOfSeason')}</p>
          
          <div>
            <h3 className="text-lg font-semibold mb-2 text-nba-blue">{t('rules.playoffQualification')}</h3>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">{t('rules.playoffQualificationText')}</p>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-2 text-nba-blue">{t('rules.playInTournament')}</h3>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">{t('rules.playInTournamentText')}</p>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-2 text-nba-blue">{t('rules.lottery')}</h3>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">{t('rules.lotteryText')}</p>
          </div>
        </div>
      </div>

      {/* V. Trades & Roster Management */}
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg dark:shadow-gray-900 p-8 mb-6">
        <h2 className="text-2xl font-bold mb-6 text-nba-blue">{t('rules.tradesRosterManagement')}</h2>
        
        <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-6 italic">{t('rules.tradesIntro')}</p>
        
        <div className="space-y-6">
          <div>
            <h3 className="text-lg font-semibold mb-2 text-nba-blue">{t('rules.roster')}</h3>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">{t('rules.rosterText')}</p>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-2 text-nba-blue">{t('rules.trades')}</h3>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">{t('rules.tradesText')}</p>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-2 text-nba-blue">{t('rules.unequalTrades')}</h3>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">{t('rules.unequalTradesText')}</p>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-2 text-nba-blue">{t('rules.tradeStaggering')}</h3>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">{t('rules.tradeStaggeringText')}</p>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-2 text-nba-blue">{t('rules.tradeValidity')}</h3>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">{t('rules.tradeValidityText')}</p>
          </div>
        </div>
      </div>

      {/* Important Notice */}
      <div className="bg-nba-blue text-white rounded-lg shadow-lg dark:shadow-gray-900 p-8 text-center">
        <h2 className="text-2xl font-bold mb-4">📋 Liga Information</h2>
        <p className="text-lg leading-relaxed">
          Diese Regeln bilden die Grundlage für faire und spannende Spiele in unserer 2K Bundesliga. 
          Bei Fragen wendet euch an die Admins. Viel Erfolg und Spaß beim Spielen! 🏀
        </p>
        <div className="mt-4">
          <p className="text-sm opacity-90">
            These rules form the foundation for fair and exciting games in our 2K Bundesliga.
            Contact the admins if you have questions. Good luck and have fun playing! 🏀
          </p>
        </div>
      </div>
    </div>
  );
};

export default Rules;
